import { render, staticRenderFns } from "./NewConversationDialog.vue?vue&type=template&id=3fd2f7fd&scoped=true"
import script from "./NewConversationDialog.vue?vue&type=script&lang=js"
export * from "./NewConversationDialog.vue?vue&type=script&lang=js"
import style0 from "./NewConversationDialog.vue?vue&type=style&index=0&id=3fd2f7fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2f7fd",
  null
  
)

export default component.exports